{% block swag_migration_shop_information %}
    <mt-banner
        v-if="showUpdateBanner"
        class="swag-migration-shop-information__updating-info"
        variant="info"
        :title="updateBannerTitle"
    >
        {{ updateBannerMessage }}
    </mt-banner>

    <mt-card
        class="swag-migration-shop-information"
        :title="$tc('swag-migration.index.shopInfoCard.cardTitle')"
        position-identifier="swag-migration-shop-information"
        :is-loading="isUpdating"
    >
        <template #headerRight>
            <div class="swag-migration-shop-information__header-right">
                <mt-link
                    class="swag-migration-shop-information__header-right-link"
                    as="a"
                    to="https://docs.shopware.com/en/migration-en"
                    type="external"
                    target="_blank"
                >
                    {{ $tc('swag-migration.index.shopInfoCard.link') }}
                </mt-link>
            </div>
        </template>

        {% block swag_migration_shop_information_content %}
            <template #grid>
                <sw-container rows="auto auto">
                    <sw-card-section
                        class="swag-migration-shop-information__connection-section"
                        :divider="showMoreInformation ? 'bottom' : ''"
                    >
                        {% block swag_migration_shop_information_connection %}
                            <div class="swag-migration-shop-information__connection">
                                <div class="swag-migration-shop-information__connection-wrapper-left">
                                {% block swag_migration_shop_information_connection_avatar %}
                                    <template v-if="profileIcon !== null && profileIcon !== ''">
                                        <img
                                            class="swag-migration-shop-information__profile-avatar"
                                            :src="assetFilter(profileIcon)"
                                             alt=""
                                        >
                                    </template>

                                    <template v-else>
                                        <img
                                            class="swag-migration-shop-information__profile-avatar"
                                            :src="assetFilter('/swagmigrationassistant/administration/static/img/migration-assistant-plugin.svg')"
                                            alt=""
                                        >
                                    </template>
                                {% endblock %}

                                {% block swag_migration_shop_information_connection_info %}
                                    <div class="swag-migration-shop-information__connection-info">
                                        {% block swag_migration_shop_information_shop_system %}
                                            <div class="swag-migration-shop-information__connection-name">
                                                {{ connectionName }}
                                            </div>
                                        {% endblock %}

                                        {% block swag_migration_shop_information_shop_domain %}
                                            <div
                                                v-if="shopUrl !== ''"
                                                class="swag-migration-shop-information__shop-domain"
                                            >
                                                <span
                                                    class="swag-migration-shop-information__shop-domain-prefix"
                                                    :class="shopUrlPrefixClass"
                                                >
                                                    <mt-icon
                                                        v-if="sslActive"
                                                        class="swag-migration-shop-information__shop-domain-prefix-icon"
                                                        name="regular-lock"
                                                        size="14px"
                                                    />

                                                    <mt-icon
                                                        v-else
                                                        class="swag-migration-shop-information__shop-domain-prefix-icon"
                                                        name="regular-lock-open"
                                                        size="14px"
                                                    />

                                                    {{ shopUrlPrefix }}
                                                </span>

                                                <span>{{ shopUrl }}</span>
                                            </div>
                                        {% endblock %}

                                        {% block swag_migration_shop_information_actions %}
                                            <div class="swag-migration-shop-information__actions">
                                                {% block swag_migration_shop_information_actions_editSettings %}
                                                    <template v-if="!connection">
                                                        <mt-button
                                                            class="swag-migration-shop-information__actions-initial"
                                                            size="small"
                                                            variant="secondary"
                                                            :disabled="!acl.can('swag_migration.creator')"
                                                            @click="onClickCreateInitialConnection"
                                                        >
                                                            {{ $tc('swag-migration.index.shopInfoCard.buttonCreateInitialConnection') }}
                                                        </mt-button>
                                                    </template>

                                                    <template v-else>
                                                        <mt-button
                                                            class="swag-migration-shop-information__actions-edit"
                                                            size="small"
                                                            variant="secondary"
                                                            :disabled="!acl.can('swag_migration.editor')"
                                                            @click="onClickEditConnectionCredentials"
                                                        >
                                                            {{ $tc('swag-migration.index.shopInfoCard.buttonEditSettings') }}
                                                        </mt-button>
                                                    </template>
                                                {% endblock %}

                                                {% block swag_migration_shop_information_actions_contextMenu %}
                                                    <sw-context-button v-if="connection">
                                                        <template #button>
                                                            <mt-button
                                                                class="swag-migration-shop-information__actions-context-menu"
                                                                size="small"
                                                                variant="secondary"
                                                                square
                                                            >
                                                                <mt-icon name="solid-ellipsis-h-s"/>
                                                            </mt-button>
                                                        </template>

                                                        {% block swag_migration_shop_information_actions_refreshConnection %}
                                                            <sw-context-menu-item
                                                                @click="onClickRefreshConnection"
                                                                :disabled="!acl.can('swag_migration.viewer')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.refreshButton') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_createConnectionItem %}
                                                            <sw-context-menu-item
                                                                @click="onClickCreateConnection"
                                                                :disabled="!acl.can('swag_migration.creator')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonCreateConnection') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_selectConnectionItem %}
                                                            <sw-context-menu-item
                                                                @click="onClickSelectConnection"
                                                                :disabled="!acl.can('swag_migration.editor')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonSelectConnection') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_profileInstallationItem %}
                                                            <sw-context-menu-item
                                                                @click="onClickProfileInstallation"
                                                                :disabled="!acl.can('swag_migration.creator')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonProfileInstallation') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_divider %}
                                                            <sw-context-menu-divider/>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_removeCredentialsItem %}
                                                            <sw-context-menu-item
                                                                variant="danger"
                                                                @click="showRemoveCredentialsConfirmModal = true"
                                                                :disabled="!acl.can('swag_migration.deleter')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonRemoveCredentials') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_resetChecksumsItem %}
                                                            <sw-context-menu-item
                                                                variant="danger"
                                                                @click="showResetChecksumsConfirmModal = true"
                                                                :disabled="!acl.can('swag_migration.deleter')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonResetChecksums') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}

                                                        {% block swag_migration_shop_information_actions_resetMigrationItem %}
                                                            <sw-context-menu-item
                                                                variant="danger"
                                                                @click="openResetMigrationModal"
                                                                :disabled="!acl.can('swag_migration.deleter')"
                                                            >
                                                                {{ $tc('swag-migration.index.shopInfoCard.buttonResetMigration') }}
                                                            </sw-context-menu-item>
                                                        {% endblock %}
                                                    </sw-context-button>
                                                {% endblock %}
                                            </div>
                                        {% endblock %}
                                    </div>
                                </div>
                                {% endblock %}

                                {% block swag_migration_shop_information_connection %}
                                    <div class="swag-migration-shop-information__connection">
                                        <div class="swag-migration-shop-information__connection-badge">
                                            <sw-label
                                                class="swag-migration-shop-information__connection-status"
                                                :variant="connectionBadgeVariant"
                                                appearance="pill"
                                            >
                                                <sw-color-badge
                                                    class="swag-migration-shop-information__connection-status-dot"
                                                    :variant="connectionBadgeVariant"
                                                    rounded
                                                />

                                                <span class="swag-migration-shop-information__connection-status-text">
                                                    {{ $tc(connectionBadgeLabel) }}
                                                </span>
                                            </sw-label>
                                        </div>
                                    </div>
                                {% endblock %}
                            </div>
                        {% endblock %}
                    </sw-card-section>

                    <sw-card-section
                        v-if="showMoreInformation"
                        class="swag-migration-shop-information__metadata-section"
                        secondary
                        slim
                    >
                        <sw-container
                            class="swag-migration-shop-information__metadata"
                            columns="repeat(auto-fit, minmax(250px, 1fr)"
                            gap="0px 15px"
                        >
                            {% block swag_migration_shop_information_metadata_columns %}
                                <div class="swag-migration-shop-information__metadata-columns">
                                    {% block swag_migration_shop_information_metadata_column_left %}
                                        {% block swag_migration_shop_information_metadata_profile %}
                                            <sw-description-list>
                                                <dt>{{ $tc('swag-migration.index.shopInfoCard.profile') }}</dt>
                                                <dd>{{ profile }}</dd>
                                            </sw-description-list>
                                        {% endblock %}

                                        {% block swag_migration_shop_information_metadata_gateway %}
                                            <sw-description-list>
                                                <dt>{{ $tc('swag-migration.index.shopInfoCard.gateway') }}</dt>
                                                <dd>{{ $tc(gateway) }}</dd>
                                            </sw-description-list>
                                        {% endblock %}
                                    {% endblock %}
                                </div>

                                <div class="swag-migration-shop-information__metadata-columns">
                                    {% block swag_migration_shop_information_column_right %}
                                        {% block swag_migration_shop_information_metadata_lastConnectionCheck %}
                                            <sw-description-list>
                                                <dt>
                                                    {{ $tc('swag-migration.index.shopInfoCard.connectionCheck') }}
                                                </dt>

                                                <dd v-if="lastConnectionCheck">
                                                    {{ formattedLastConnectionCheckDate }}
                                                </dd>

                                                <dd v-else>
                                                    {{ $tc('swag-migration.index.shopInfoCard.noConnectionCheckDoneYet') }}
                                                </dd>
                                            </sw-description-list>
                                        {% endblock %}

                                        {% block swag_migration_shop_information_metadata_lastMigration %}
                                            <sw-description-list>
                                                <dt>{{ $tc('swag-migration.index.shopInfoCard.lastMigration') }}</dt>

                                                <dd v-if="lastMigrationDate !== '-'">
                                                    {{ formattedLastMigrationDateTime }}
                                                </dd>

                                                <dd v-else>
                                                    {{ $tc('swag-migration.index.shopInfoCard.noMigrationDoneYet') }}
                                                </dd>
                                            </sw-description-list>
                                        {% endblock %}
                                    {% endblock %}
                                </div>
                            {% endblock %}
                        </sw-container>
                    </sw-card-section>
                </sw-container>

                {% block swag_migration_shop_information_remove_credentials_confirm_modal %}
                    <sw-modal
                        v-if="showRemoveCredentialsConfirmModal"
                        class="swag-migration-shop-information__confirm-modal"
                        :title="$tc('swag-migration.index.shopInfoCard.removeCredentialsConfirmDialog.title')"
                        :is-loading="confirmModalIsLoading"
                        variant="small"
                        @modal-close="showRemoveCredentialsConfirmModal = false"
                    >
                        {% block swag_migration_shop_information_remove_credentials_confirm_modal_content_hint %}
                            <p class="swag-migration-shop-information__confirm-modal-content-hint">
                                {{ $tc('swag-migration.index.shopInfoCard.removeCredentialsConfirmDialog.contentHint') }}
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_remove_credentials_confirm_modal_content %}
                            <p class="swag-migration-shop-information__confirm-modal-content">
                                {{ $tc('swag-migration.index.shopInfoCard.removeCredentialsConfirmDialog.content') }}
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_remove_credentials_confirm_modal_footer %}
                            <template #modal-footer>
                                {% block swag_migration_shop_information_remove_credentials_confirm_modal_abort %}
                                    <mt-button
                                        size="small"
                                        variant="secondary"
                                        :disabled="confirmModalIsLoading"
                                        @click="showRemoveCredentialsConfirmModal = false"
                                    >
                                        {{ $tc('swag-migration.index.shopInfoCard.removeCredentialsConfirmDialog.abortButtonText') }}
                                    </mt-button>
                                {% endblock %}

                                {% block swag_migration_shop_information_remove_credentials_confirm_modal_confirm %}
                                    <mt-button
                                        size="small"
                                        variant="critical"
                                        :disabled="confirmModalIsLoading || !acl.can('swag_migration.deleter')"
                                        @click="onClickRemoveConnectionCredentials"
                                    >
                                        {{ $tc('global.default.delete') }}
                                    </mt-button>
                                {% endblock %}
                            </template>
                        {% endblock %}
                    </sw-modal>
                {% endblock %}

                {% block swag_migration_shop_information_reset_checksums_confirm_modal %}
                    <sw-modal
                        v-if="showResetChecksumsConfirmModal"
                        class="swag-migration-shop-information__confirm-modal"
                        :title="$tc('swag-migration.index.shopInfoCard.resetChecksumsConfirmDialog.title')"
                        :is-loading="confirmModalIsLoading"
                        variant="small"
                        @modal-close="showResetChecksumsConfirmModal = false"
                    >
                        {% block swag_migration_shop_information_reset_checksums_confirm_modal_content_hint %}
                            <p class="swag-migration-shop-information__confirm-modal-content-hint">
                                {{ $tc('swag-migration.index.shopInfoCard.resetChecksumsConfirmDialog.contentHint') }}
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_reset_checksums_confirm_modal_content %}
                            <p
                                class="swag-migration-shop-information__confirm-modal-content"
                                v-html="$tc('swag-migration.index.shopInfoCard.resetChecksumsConfirmDialog.content')"
                            >
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_reset_checksums_confirm_modal_footer %}
                            <template #modal-footer>
                                {% block swag_migration_shop_information_reset_checksums_confirm_modal_abort %}
                                    <mt-button
                                        size="small"
                                        variant="secondary"
                                        :disabled="confirmModalIsLoading"
                                        @click="showResetChecksumsConfirmModal = false"
                                    >
                                        {{ $tc('swag-migration.index.shopInfoCard.resetChecksumsConfirmDialog.abortButtonText') }}
                                    </mt-button>
                                {% endblock %}

                                {% block swag_migration_shop_information_reset_checksums_confirm_modal_confirm %}
                                    <mt-button
                                        size="small"
                                        variant="critical"
                                        :disabled="confirmModalIsLoading || !acl.can('swag_migration.deleter')"
                                        @click="onClickResetChecksums"
                                    >
                                        {{ $tc('swag-migration.index.shopInfoCard.resetChecksumsConfirmDialog.confirmButtonText') }}
                                    </mt-button>
                                {% endblock %}
                            </template>
                        {% endblock %}
                    </sw-modal>
                {% endblock %}

                {% block swag_migration_shop_information_reset_migration_confirm_modal %}
                    <sw-modal
                        v-if="showResetMigrationConfirmModal"
                        class="swag-migration-shop-information__confirm-modal"
                        :title="$tc('swag-migration.index.shopInfoCard.resetMigrationConfirmDialog.title')"
                        :is-loading="confirmModalIsLoading"
                        variant="small"
                        @modal-close="onCloseResetModal"
                    >
                        {% block swag_migration_shop_information_reset_migration_confirm_modal_header %}
                            <p
                                class="swag-migration-shop-information__confirm-modal-header"
                                v-html="$tc('swag-migration.index.shopInfoCard.resetMigrationConfirmDialog.header')"
                            >
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_reset_migration_confirm_modal_content %}
                            <p
                                class="swag-migration-shop-information__confirm-modal-content"
                                v-html="$tc('swag-migration.index.shopInfoCard.resetMigrationConfirmDialog.content')"
                            >
                            </p>
                        {% endblock %}

                        {% block swag_migration_shop_information_reset_migration_confirm_modal_footer %}
                            <template #modal-footer>
                                {% block swag_migration_shop_information_reset_migration_confirm_modal_abort %}
                                    <mt-button
                                        size="small"
                                        variant="secondary"
                                        :disabled="confirmModalIsLoading"
                                        @click="onCloseResetModal"
                                    >
                                        {{ $tc('swag-migration.index.shopInfoCard.resetMigrationConfirmDialog.abortButtonText') }}
                                    </mt-button>
                                {% endblock %}

                                {% block swag_migration_shop_information_reset_migration_confirm_modal_confirm %}
                                    <mt-button
                                        size="small"
                                        variant="critical"
                                        :disabled="confirmModalIsLoading || !acl.can('swag_migration.deleter')"
                                        @click="onClickResetMigration"
                                    >
                                        {{ $tc('swag-migration.index.shopInfoCard.resetMigrationConfirmDialog.confirmButtonText') }}
                                    </mt-button>
                                {% endblock %}
                            </template>
                        {% endblock %}
                    </sw-modal>
                {% endblock %}
            </template>
        {% endblock %}
    </mt-card>
{% endblock %}
